import React from "react";
import styled from "styled-components";
import { BatteryFull } from "@material-ui/icons";

import { DevicePrimaryParameter } from "../models/IGeolocation";
import { VolumeIcon } from "../../components/VolumeIcon";
import { ThermometerIcon } from "../../components/ThermometerIcon";

export interface IDeviceIcon {
  parameter?: DevicePrimaryParameter;
}

export const LocationVolumeIcon = styled(VolumeIcon)`
  color: #fff;
`;
LocationVolumeIcon.displayName = "LocationVolumeIcon";

export const LocationTemperatureIcon = styled(ThermometerIcon)`
  color: #fff;
`;
LocationTemperatureIcon.displayName = "LocationTemperatureIcon";

export const LocationChargeIcon = styled(BatteryFull)`
  color: #fff;
`;
LocationChargeIcon.displayName = "LocationChargeIcon";

export const DefaultLocationDeviceIcon: React.FunctionComponent = props => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fillRule="evenodd">
      <path
        style={{
          fill: "currentColor"
        }}
        d="M6.66907138,0.0458515284 C3.06387084,2.18077376 0.624,6.1665087 0.624,10.7611023 C0.624,15.3801429 3.09084228,19.3814397 6.72801088,21.5075295 C4.30873827,19.0526423 2.73837797,15.1700049 2.73837797,10.7611023 C2.73837797,6.38327102 4.27906458,2.50384058 6.66902039,0.0458515284 L6.66907138,0.0458515284 Z M18.7877152,0.167349885 C21.1113385,2.63106949 22.598898,6.45477157 22.598898,10.7611023 C22.598898,15.0788942 21.0932896,18.8902415 18.7590102,21.3530673 C22.2611176,19.1915952 24.624,15.275731 24.624,10.7609972 C24.624,6.24647365 22.277535,2.33181867 18.7876642,0.167349885 L18.7877152,0.167349885 Z M9.64699456,2.62360399 C6.51519646,3.91781648 4.28706934,7.06925569 4.28706934,10.7609972 C4.28706934,14.4628855 6.53018627,17.6093827 9.67554657,18.8968132 C7.56738885,17.3063466 6.13356832,14.2611593 6.13356832,10.7611023 C6.13356832,7.2719282 7.54964582,4.2182765 9.64689259,2.62360399 L9.64699456,2.62360399 Z M16.9124602,3.08520312 C18.706138,4.76562371 19.8599449,7.58374419 19.8599449,10.7609972 C19.8599449,13.975052 18.6821747,16.7949074 16.8534697,18.4680728 C19.5050333,16.9828592 21.3194623,14.0915032 21.3194623,10.7611549 C21.3194623,7.45499063 19.5323107,4.58024802 16.9124602,3.08536084 L16.9124602,3.08520312 Z M11.0378851,5.40182086 C8.86334398,6.15573105 7.30955404,8.26468176 7.30955404,10.7611023 C7.30955404,13.2799194 8.88847995,15.4141056 11.0937145,16.1499304 C9.7147036,15.1743685 8.74990075,13.1384956 8.74990075,10.7611023 C8.74990075,8.41772447 9.69094426,6.39368066 11.0378851,5.40182086 Z M15.0195642,5.57762809 C16.23486,6.62521626 17.0254446,8.55962152 17.0254446,10.7611023 C17.0254446,12.9962305 16.2101829,14.9396785 14.9637349,15.975753 C16.9224024,15.1102283 18.2969266,13.0975405 18.2969266,10.7610498 C18.2969266,8.44779676 16.9470286,6.45697968 15.0195642,5.57762809 Z M12.9817158,9.11322502 C11.9467056,9.11322502 11.1079905,9.97806621 11.1079905,11.045317 C11.1079905,11.8593718 11.5960768,12.5564496 12.2870354,12.8410323 L12.2870354,24.0458515 L13.6763963,24.0458515 L13.6763963,12.8410323 C14.3676608,12.5566073 14.8554412,11.8595821 14.8554412,11.045317 C14.8554412,9.97806621 14.016726,9.11322502 12.9817158,9.11322502 Z"
      />
    </g>
  </svg>
);
DefaultLocationDeviceIcon.displayName = "DefaultLocationDeviceIcon";

export const DefaultLocationPressureIcon: React.FunctionComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 30 30"
    version="1.1"
    {...props}
  >
    <g fillRule="evenodd">
      <path
        style={{
          fill: "currentColor"
        }}
        d="M 15 3 C 9.4886661 3 5 7.4886661 5 13 C 5 18.174135 8.9555284 22.447699 14 22.951172 L 14 25 L 12 25 C 11.448 25 11 25.448 11 26 L 5 26 A 1.0001 1.0001 0 1 0 5 28 L 11 28 C 11 28.552 11.448 29 12 29 L 18 29 C 18.552 29 19 28.552 19 28 L 25 28 A 1.0001 1.0001 0 1 0 25 26 L 19 26 C 19 25.448 18.552 25 18 25 L 16 25 L 16 22.951172 C 21.044472 22.447699 25 18.174135 25 13 C 25 7.4886661 20.511334 3 15 3 z M 15 5 C 19.430666 5 23 8.5693339 23 13 C 23 17.392422 19.490762 20.933254 15.113281 20.994141 A 1.0001 1.0001 0 0 0 14.984375 20.986328 A 1.0001 1.0001 0 0 0 14.875 20.994141 C 10.503015 20.927054 7 17.388476 7 13 C 7 8.5693339 10.569334 5 15 5 z M 17.980469 8.9902344 A 1.0001 1.0001 0 0 0 17.292969 9.2929688 L 15.511719 11.074219 C 15.347332 11.030549 15.178179 11 15 11 C 13.895 11 13 11.895 13 13 C 13 14.105 13.895 15 15 15 C 16.105 15 17 14.105 17 13 C 17 12.821821 16.969451 12.652668 16.925781 12.488281 L 18.707031 10.707031 A 1.0001 1.0001 0 0 0 17.980469 8.9902344 z"
      />
    </g>
  </svg>
);

export const DefaultLocationTurbidityIcon: React.FunctionComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="30px"
    viewBox="0 0 24 24"
    version="1.1"
    {...props}
  >
    <g fillRule="evenodd">
      <path
        style={{
          fill: "currentColor"
        }}
        d="M 13 0.09375 C 13 0.09375 4 11 4 17 C 4 21.972656 8.027344 26 13 26 C 17.972656 26 22 21.972656 22 17 C 22 11 13 0.09375 13 0.09375 Z M 9.074219 17.589844 C 9.074219 19.015625 9.742188 21.839844 10.207031 23.015625 C 7.164063 21.523438 6.359375 18.589844 6.359375 16.554688 C 6.359375 13.378906 10.046875 8.730469 12.136719 4.402344 C 11.90625 6.675781 9.074219 13.269531 9.074219 17.589844 Z "
      />
    </g>
  </svg>
);

export const DefaultLocationLevelIcon: React.FunctionComponent = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 16 16"
    version="1.1"
    {...props}
  >
    <g fillRule="evenodd">
      <path
        style={{
          fill: "currentColor"
        }}
        d="M 7.46875 1 A 0.50005 0.50005 0 0 0 7.2871094 1.046875 L 3.2871094 2.921875 A 0.50005 0.50005 0 0 0 3 3.375 L 3 7.5 A 0.50005 0.50005 0 0 0 3.5 8 L 4.0195312 8 L 2.0527344 14 L 3.1035156 14 L 3.4375 12.984375 L 7.5 11.269531 L 11.5625 12.984375 L 11.896484 14 L 12.947266 14 L 10.980469 8 L 11.5 8 A 0.50005 0.50005 0 0 0 12 7.5 L 12 3.375 A 0.50005 0.50005 0 0 0 11.712891 2.921875 L 7.7128906 1.046875 A 0.50005 0.50005 0 0 0 7.46875 1 z M 7.5 2.0527344 L 11 3.6933594 L 11 7 L 4 7 L 4 3.6933594 L 7.5 2.0527344 z M 5.0703125 8 L 9.9296875 8 L 10.263672 9.0175781 L 7.5 10.183594 L 4.7363281 9.0175781 L 5.0703125 8 z M 4.4238281 9.9726562 L 6.2128906 10.726562 L 3.8496094 11.722656 L 4.4238281 9.9726562 z M 10.576172 9.9726562 L 11.150391 11.722656 L 8.7871094 10.726562 L 10.576172 9.9726562 z"
      />
    </g>
  </svg>
);

export const LocationLevelIcon = styled(DefaultLocationLevelIcon)`
  color: #fff;
`;

export const LocationPressureIcon = styled(DefaultLocationPressureIcon)`
  color: #fff;
`;

export const LocationTurbidityIcon = styled(DefaultLocationTurbidityIcon)`
  color: #fff;
`;

export const LocationDeviceIcon = styled(DefaultLocationDeviceIcon)`
  color: #fff;
`;
LocationDeviceIcon.displayName = "LocationDeviceIcon";

export const DeviceIcon: React.FunctionComponent<IDeviceIcon> = ({
  parameter
}) => {
  if (parameter === DevicePrimaryParameter.VOLUME) {
    return <LocationVolumeIcon />;
  } else if (parameter === DevicePrimaryParameter.LEVEL) {
    return <LocationLevelIcon />;
  } else if (parameter === DevicePrimaryParameter.TEMPERATURE) {
    return <LocationTemperatureIcon />;
  } else if (parameter === DevicePrimaryParameter.TURBIDITY) {
    return <LocationTurbidityIcon />;
  } else if (parameter === DevicePrimaryParameter.CHARGE_LEVEL) {
    return <LocationChargeIcon />;
  } else if (parameter === DevicePrimaryParameter.PRESSURE) {
    return <LocationPressureIcon />;
  }
  return <LocationDeviceIcon />;
};
DeviceIcon.displayName = "DeviceIcon";
